import {
  Text,
  HStack,
  Popover,
  PopoverContent,
  PopoverTrigger,
  VStack,
} from "@chakra-ui/react";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import React, { memo } from "react";
import colors from "app/colors";
import { VerticalEllipsisIcon } from "modules/icons";
import MessagePopoverForwardMessageButton from "../messages/message-popover/message-popover-forward-message-button";
import useTask from "modules/hooks/use-task";
import useRemovedFromThread from "modules/hooks/use-removed-from-thread";
import MessagePopoverCopyMessageButton from "../messages/message-popover/message-popover-copy-message-button";
import MessagePopoverEditMessageButton from "../messages/message-popover/message-popover-edit-message-button";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
}

const TaskMessagePopover = ({ messageThread, message }: IProps) => {
  const { isMeRemoved } = useRemovedFromThread(messageThread);
  const { isTaskClosed, isCreatorOrAssignee } = useTask({
    messageThread,
  });

  const allowModify = !isTaskClosed && !isMeRemoved && isCreatorOrAssignee;

  return (
    <Popover
      trigger="hover"
      placement="bottom-start"
      returnFocusOnClose={false}
      flip
      isLazy
    >
      <PopoverTrigger>
        <HStack spacing={0} cursor="pointer">
          <VerticalEllipsisIcon fill={colors.blue} />
          <Text color={colors.blue} fontSize={12} fontWeight={600}>
            Options
          </Text>
        </HStack>
      </PopoverTrigger>
      <PopoverContent w="full">
        <VStack w="full" alignItems="flex-start" spacing={3} p={2}>
          {allowModify && (
            <MessagePopoverEditMessageButton
              message={message}
              displayText="Edit Description"
            />
          )}
          <MessagePopoverCopyMessageButton
            messageThread={messageThread}
            message={message}
          />
          <MessagePopoverForwardMessageButton
            message={message}
            messageThread={messageThread}
            displayText="Forward Message"
          />
        </VStack>
      </PopoverContent>
    </Popover>
  );
};

export default memo(TaskMessagePopover);
